import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import { format } from "date-fns";
import { ordinalize } from "@/utilities/ordinalize";

export default {
  name: "workOrderShow",
  props: { workOrderId: String },
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Work Order...",
      sortBy: "item_date",
      lineItemFields: [
        { key: "item_date", label: "Date", sortable: true },
        { key: "quantity", label: "Quantity", sortable: true },
        { key: "description", label: "Description", sortable: true },
        { key: "rate", label: "Rate", sortable: true },
        { key: "total", label: "Total", sortable: true },
      ],
    };
  },
  created() {
    this.loadWorkOrder().then(() => {
      this.dataLoaded = true;
    });
  },
  computed: {
    workOrder: function() {
      return this.$store.getters.workOrder;
    },
    isFieldWorker: function() {
      return this.$store.getters.isFieldWorker;
    },
  },
  methods: {
    ordinalize: function(i) {
      return ordinalize(i);
    },
    loadWorkOrder() {
      const jsConnWorkOrder = new JSConn();
      const jsConnLineItems = new JSConn();
      const jsConnLotUnits = new JSConn();

      jsConnWorkOrder.formParams = {
        id: this.workOrderId,
      };

      const dataPromises = [
        this.$store.dispatch("needWorkOrder", jsConnWorkOrder),
        this.$store.dispatch("needLotUnits", jsConnLotUnits),
        this.$store.dispatch("needLineItems", jsConnLineItems),
      ];

      return Promise.all(dataPromises);
    },
    reloadWorkOrder() {
      // as of 2019-04-25 all the child elements are emitting an event
      // that calls this function. If different things are needed for performance
      // reasons, this can be changed to handle each event separately
      return this.loadWorkOrder();
    },
    createWorkOrderCopy() {
      const jsConn = new JSConn();
      const td = format(new Date(), "yyyy-MM-dd");

      jsConn.formParams = {
        work_order_id: this.workOrderId,
        submitted_date: td,
      };

      this.$store.dispatch("createWorkOrderFromWorkOrder", jsConn).then(() => {
        this.$router.push({
          name: "workOrders",
        });
        return Promise.resolve();
      });
    },
  },
};
